import i18n from '../../locales/index'
import { genBasicStore } from '../vuex'
import axios from 'axios';

const store = genBasicStore('limited_time_activity')

store.actions.toggleRun = function ({ commit }, id) {
  return axios.post(`/limited_time_activities/${id}/run`);
}

export default store;
